import React from 'react'
import json from "./EducationData.json"
const Education = () => {
  return (
    <div>
          <div className="container">
          <div className="relative mt-8 grid grid-cols-2 gap-12   lg:grid-cols-3 ">
          {json &&
            json.map((item, index) => {
              return (
                <div className="shadow-lg mx-4  shadow-[#30dada] dark:shadow-[#17A6DB] hover:translate-x-5 hover:duration-500   rounded-[16px] border-[4px] border-[#17A6DB] py-4 dark:border-[#30dada]" >
                  <div>
                    <div className="py-4  mx-4 mt-4 text-[12px] lg:text-[16px] font-bold text-[#17A6DB]  dark:text-[#30dada]"> {item.CollageName}</div>
                   
                    <div className="horizontal1"></div>
                    <p className=" mx-4  mt-4 text-[12px] lg:text-[16px] font-bold  dark:text-[#FFFFFF]">
                      {item.Branch}
                    </p>
                    <p className=" mx-4 mt-4 text-[12px] lg:text-[16px] font-bold  dark:text-[#FFFFFF]">
                      {item.year}
                    </p>
                    </div>
                   
                </div>
              );
            })}
        </div>
        
          </div>
    </div>
  )
}

export default Education